import { Person } from "@mui/icons-material";
import UserList from "./UserList";

const UserResourceProps = {
	name: "user",
	list: UserList,
};

export const UserMenuProps = {
	to: "/user",
	primaryText: "Utilisateurs",
	icon: Person,
};

export default UserResourceProps;
